import React from "react";
import "./SideMenu.css";
import { Link, useNavigate } from "react-router-dom";

export default function  SideMenu() {
  const navi = useNavigate();
  return (
    <div className="hideSideMenu">
      <div className="bg-white d-flex my-1 sideMenuProp justify-content-between rounded shadow" onClick={() => navi("/")}>
        <p className="my-3 mx-2 fw-bold">Home</p>{" "}
        <div className="side-red-button my-2 mx-2">
          <Link className="mx-4 fw-bold side-red-button-link">View</Link>
        </div>{" "}
      </div>
      <div className="bg-white d-flex my-1 sideMenuProp justify-content-between rounded shadow" onClick={() => navi("/AccountDetails")} >
        <p className="my-3 mx-2 fw-bold">My Account</p>{" "}
        <div className="side-red-button my-2 mx-2">
          <Link className="mx-4 fw-bold side-red-button-link">View</Link>
        </div>{" "}
      </div>
      <div className="bg-white d-flex my-1 sideMenuProp justify-content-between rounded shadow" onClick={() => navi("/Settings")}>
        <p className="my-3 mx-2 fw-bold">Account Settings</p>{" "}
        <div className="side-red-button my-2 mx-2">
          <Link className="mx-4 fw-bold side-red-button-link">View</Link>
        </div>{" "}
      </div>
      <div className="bg-white d-flex my-1 sideMenuProp justify-content-between rounded shadow"  onClick={() => navi("/myprofile")}>
        <p className="my-3 mx-2 fw-bold">Profiles</p>{" "}
        <div className="side-red-button my-2 mx-2">
          <Link className="mx-4 fw-bold side-red-button-link">View</Link>
        </div>{" "}
      </div>
      <div className="bg-white d-flex my-1 sideMenuProp justify-content-between rounded shadow"  onClick={() => navi("/BillingAndPayments")}>
        <p className="my-3 mx-2 fw-bold">Billing And Payments</p>{" "}
        <div className="side-red-button my-2 mx-2">
          <Link className="mx-4 fw-bold side-red-button-link">View</Link>
        </div>{" "}
      </div>
      <div className="bg-white d-flex my-1 sideMenuProp justify-content-between rounded shadow"  onClick={() => navi("/Bookings")}>
        <p className="my-3 mx-2 fw-bold">Bookings</p>{" "}
        <div className="side-red-button my-2 mx-2">
          <Link className="mx-4 fw-bold side-red-button-link">View</Link>
        </div>{" "}
      </div>
    
    

      <div className="bg-white d-flex my-1 sideMenuProp justify-content-between rounded shadow"  onClick={() => navi("/HelpAndSupport")}>
        <p className="my-3 mx-2 fw-bold">Help & support</p>{" "}
        <div className="side-red-button my-2 mx-2">
          <Link className="mx-4 fw-bold side-red-button-link">View</Link>
        </div>{" "}
      </div>
      <div className="bg-white d-flex my-1 sideMenuProp justify-content-between rounded shadow" onClick={() => navi("/MySubscriptionsAndTokens")}>
        <p className="my-3 mx-2 fw-bold">Subscriptions & Classes</p>{" "}
        <div className="side-red-button my-2 mx-2">
          <Link className="mx-4 fw-bold side-red-button-link">View</Link>
        </div>{" "}
      </div>
  

    </div>
  );
}
